import { createSlice } from '@reduxjs/toolkit'

export const dataManager = createSlice({
  name: 'dataManager',
  initialState: {
    stores: {},
    coordinates : {
      lat : '',
      lng : ''
    }
  },
  reducers: {
    insertStores: (state,actions) => {
      state.stores = actions.payload;
      return state;
    },
    insertCoordinates: (state, actions) => {
      state.coordinates = actions.payload;
      return state;
    },
  }
});


export const { insertStores, insertCoordinates } = dataManager.actions;

export default dataManager.reducer;